import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ForgotPasswordForm} from 'components/forgotpassword';
import title from 'constants/TitlePages.js';

class ForgotPassword extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.forgotPassword;
  }

  render() {
    return (
      <MasterLayout>
        <ForgotPasswordForm/>
      </MasterLayout>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./pages/ForgotPassword.jsx